import { Card, Text } from '@backyard-ui/core';

export default function RestrictionMessage() {
  return (
    <Card.Root
      shadow="none"
      hasBorder
      UNSAFE_className="border-green-500 bg-green-100 py-1"
      data-testid="restriction-notice"
    >
      <Card.Body>
        <Text size="md">
          Atenção! Nossos produtos são vendidos apenas para uso e consumo.
        </Text>
      </Card.Body>
    </Card.Root>
  );
}
